"use client";

import React from "react";
import { Bed, Bath, Users, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const propertySpecs = [{
  icon: Users,
  value: "9",
  label: "Guests"
}, {
  icon: Bed,
  value: "4",
  label: "Beds"
}, {
  icon: Bath,
  value: "3",
  label: "Baths"
}];
export default function TheParadisePalmsExperience() {
  return <section data-section-id="174144" id="your-tropical-sanctuary" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-shadow-color/5 group">
            <img src="https://paradisepalmsmobay.com/wp-content/uploads/2026/04/image0.png" alt="Paradise Palms Villa Entrance" className="w-full h-[500px] md:h-[600px] lg:h-[800px] object-cover transition-transform duration-700 group-hover:scale-105" />
            
            {}
            <div className="absolute top-6 right-6 md:top-8 md:right-8 z-10">
              <Badge variant="secondary" className="bg-card/90 backdrop-blur-md border border-border/50 shadow-xl text-foreground px-4 py-2.5 rounded-full flex items-center gap-2.5 text-sm font-medium"><span className="relative flex h-2.5 w-2.5" data-ast-id="f:/src/pages/Home/sections/TheParadisePalmsExperience.tsx|sig:xu4f5d" data-ast-start="1454" data-ast-end="1750"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" data-ast-id="f:/src/pages/Home/sections/TheParadisePalmsExperience.tsx|sig:2ujadb" data-ast-start="1517" data-ast-end="1625"></span><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary" data-ast-id="f:/src/pages/Home/sections/TheParadisePalmsExperience.tsx|sig:artm6p" data-ast-start="1644" data-ast-end="1726"></span></span>4 Wendy Close, Montego Bay</Badge>
            </div>
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
          </div>

          {}
          <div className="flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 text-muted-foreground mb-6">
              <MapPin className="w-4 h-4 text-primary" />
              <span className="text-sm font-semibold tracking-wider uppercase">
                Paradise Palms • Montego Bay, Jamaica
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-10 font-sans leading-[1.1]">
              Your Tropical Sanctuary
            </h2>

            {}
            <div className="grid grid-cols-3 gap-3 md:gap-6 mb-10">
              {propertySpecs.map((spec, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center p-5 md:p-6 rounded-3xl bg-card/60 border border-border/40 backdrop-blur-sm transition-all hover:-translate-y-1 hover:shadow-lg hover:bg-card/80 duration-300">
                  <spec.icon className="w-8 h-8 md:w-10 md:h-10 text-primary mb-3 md:mb-4 stroke-[1]" />
                  <span className="text-2xl md:text-3xl font-bold text-foreground leading-none mb-1 md:mb-2">
                    {spec.value}
                  </span>
                  <span className="text-xs md:text-sm font-semibold text-muted-foreground uppercase tracking-widest">
                    {spec.label}
                  </span>
                </div>)}
            </div>

            {}
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-10 font-sans">Experience the ultimate Caribbean retreat at 4 Wendy Close. Our modern villa in Montego Bay offers a seamless blend of island charm and coastal luxury. Designed for up to nine guests, this spacious sanctuary features premium amenities including a 24-hour front desk, airport transfers, and easy access to the beach—all tailored for your comfort and relaxation.</p>

            {}
            <div className="flex items-center gap-4">
              <Button asChild size="lg" className="rounded-full px-8 h-14 text-base shadow-lg shadow-primary/20 bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
                <Link to="/ReservationPage">Reserve Your Stay</Link>
              </Button>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}